import { toast } from '@hivebrite/design-system/Toast';

export const displayChinaLocationVPNToast = () => {
  const isFromChina = window.is_from_china;

  if (isFromChina) {
    toast(
      __(
        'Based on your location, location suggestions may not appear while typing. To enable this feature, please connect to a VPN',
      ),
      {
        duration: Number.POSITIVE_INFINITY,
        id: 'location-vpn-warning',
      },
    );
  }
};
